import {
  Component,
  forwardRef,
  Injector,
  OnInit,
  AfterContentInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

import { FormCommonFunctions2 } from '../form-common-functions';

@Component({
  selector: 'appForm2-wide-checkbox',
  styleUrls: ['../form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WideCheckBox2Component),
      multi: true,
    },
  ],
  template: `
    <div class="p-grid form-group">
      <div class="p-col-12 p-md-3">
        <div class="wide-label">
          <label
            class="wide-label"
            *ngIf="!showToolTip"
            style="display:inline; margin-right: 6px"
            [innerHTML]="htmlAttributes['label']['value'] || control.label"
          ></label>
          <label
            class="wide-label"
            *ngIf="showToolTip"
            style="display:inline; margin-right: 6px"
            >{{ htmlAttributes['label']['value'] || control.label }}
            <span
              class="{{ tooltip['class'] }}"
              [tooltipStyleClass]="tooltip['tooltipStyleClass']"
              [tooltipPosition]="tooltip['tooltipPosition']"
              [pTooltip]="tooltip['msg']"
              [escape]="false"
            >
              ?</span
            >
          </label>
        </div>
      </div>

      <div
        class="p-col-12 p-md-9"
        [class.has-danger]="control.showErrors || null"
      >
        <p-checkbox
          [binary]="true"
          class="checker"
          [(ngModel)]="value"
          [disabled]="disabled"
          (onChange)="pushChanges($event.checked)"
          [attr.id]="htmlAttributes['input']['id']"
          [attr.form-control-name]="control['name']"
        ></p-checkbox>

        <div *ngIf="control.showErrors" class="vendium-tool-tip">
          <p
            *ngFor="let error of control.mergedErrors"
            class="form-control-feedback"
          >
            <span><i class="fa fa-times"></i> </span
            ><span [innerHTML]="error"></span>
          </p>
        </div>
      </div>
    </div>
  `,
})
export class WideCheckBox2Component
  extends FormCommonFunctions2
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  value: boolean;
  onChange: (_: any) => void;
  onTouched: () => void;
  disabled: boolean;
  ngControl: NgControl;

  constructor(private inj: Injector) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.ngControl = this.inj.get(NgControl);
    this.control = this.ngControl;
  }

  ngAfterContentInit() {
    this.control = this.ngControl.control;
  }

  writeValue(value: any): void {
    this.value = value !== undefined ? !!value : null;
  }
  pushChanges(value: boolean) {
    this.onChange(value ? 1 : 0);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
